import { Button } from 'app/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'app/components/ui/dialog';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import TagForm from '../form';
import { Form } from 'app/components/ui/form';
import { useEffect } from 'react';
import { useProductsSlice } from 'app/pages/Product/slice';

interface Props {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  data: any;
}

export function DialogUpdateCourseTags({ isOpen, onOpenChange, data }: Props) {
  const form = useForm();

  const { useUpdateProductTagsMutation } = useProductsSlice();
  const [updateTags, { isLoading, error, data: tagData }] =
    useUpdateProductTagsMutation();

  useEffect(() => {
    if (data) {
      form.setValue('tag_name', data.tag_name);
      form.setValue('slug', data.slug);
      form.setValue('id', data.tag_id);
    }
  }, [data, form]);

  const onSubmit = data => {
    updateTags(data);
  };

  useEffect(() => {
    if (tagData) {
      toast.success(tagData?.message);
      onOpenChange(false);
    }
  }, [tagData, onOpenChange]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.error);
    }
  }, [error]);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Tag</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="space-y-4 p-4"
          >
            <TagForm />

            <DialogFooter>
              <Button variant="outline" onClick={() => onOpenChange(false)}>
                Cancel
              </Button>
              <Button type="submit" disabled={isLoading}>
                {isLoading ? 'Saving...' : 'Save Changes'}
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
}

export default DialogUpdateCourseTags;
